import {
  CollapsableItemList,
  Container,
  Layout,
  MultiSearch,
  Padding,
  Sheet,
  Text,
} from "@kidslivesafe/sc-react";
import React from "react";
import { useMultiSearchProps } from "../../../hooks/multiSearchPropsHook";
import { useAppSelector } from "../../../hooks/hooks";
import {
  selectPeopleReportHistory,
  selectReportHistoryStatus,
} from "../../../features/reports/reportsSlice";
import ActivityHistoryLineItem from "../../../components/UIComponents/ActivityHistory/ActivityHistoryLineItem";
import PeopleHistoryMap from "./PeopleHistoryMap";

import MonitoringContainer from "../../../components/UIComponents/MonitoringContainer/MontitoringContainer";
import SpacerMultiSearch from "../../../components/UIComponents/SpacerMultiSearch/SpacerMultiSearch";

const PeopleHome: React.FC = () => {
  const reportHistory = useAppSelector(selectPeopleReportHistory);
  const reportHistoryStatus = useAppSelector(selectReportHistoryStatus);

  const loading = reportHistoryStatus === "loading";

  const multiSearchProps = useMultiSearchProps(
    {
      footer: true,
      showCancel: false,
      topPadding: "xs",
      resetInput: true,
      buttonText: "New Search",
      openTab: "people",
      tabs: ["people"],
    },
    "people-home",
  );

  return (
    <>
      <Container>
        <Sheet>
          <Padding left="md" right="md" top="md">
            <Layout type="flex" flexProps={{ gap: "xs", direction: "column" }}>
              <Text tag="h3" textAlign="center">
                People Search
              </Text>
              <Text size="sm" textAlign="center">
                Search billions of pieces of data from millions of national,
                state, and local public records.{" "}
              </Text>
            </Layout>
          </Padding>
        </Sheet>
      </Container>
      <MultiSearch {...multiSearchProps} />
      <Sheet>
        <Padding space="md">
          <Layout type="flex" flexProps={{ gap: "xs", direction: "column" }}>
            <Container
              containerTitle="People Report History"
              containerId="people-home__activity-history__container"
            >
              <PeopleHistoryMap />
              <CollapsableItemList>
                {loading ? (
                  Array(5)
                    .fill(null)
                    .map((_, index) => (
                      <ActivityHistoryLineItem
                        report={undefined}
                        loading={loading}
                        loadingKey={index}
                        key={index}
                      />
                    ))
                ) : reportHistory && reportHistory.length > 0 ? (
                  reportHistory.map(report =>
                    report ? (
                      <ActivityHistoryLineItem
                        report={report}
                        loadingKey={report.score}
                        key={report.score}
                      />
                    ) : null,
                  )
                ) : (
                  <Padding space="md">
                    <Text size="xs">
                      Get started by searching a name above.
                    </Text>
                  </Padding>
                )}
              </CollapsableItemList>
            </Container>
            <MonitoringContainer
              monitoringType={"People"}
              containerId="people-home__report-monitoring__container"
            />
          </Layout>
        </Padding>
        <SpacerMultiSearch options={["property", "phone", "social"]} />
      </Sheet>
    </>
  );
};

export default PeopleHome;
